var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blob",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.19629987526287 579.1523631512994C129.66482830493004 545.5859289268528 -28.72677739015868 316.56492266057586 12.357140863422046 224.6068767011032C53.44105911700277 132.64883074163055 376.1683378264144 -6.162346829984038 469.69980939674724 27.40408739446258C563.2312809670801 60.970521618909196 614.6298885389998 334.04743608831023 573.5459702854191 426.0054820477829C532.4620520318384 517.9635280072562 316.7277714455957 612.7187973757461 223.19629987526287 579.1523631512994C129.66482830493004 545.5859289268528 -28.72677739015868 316.56492266057586 12.357140863422046 224.6068767011032 ",
    fill: "hsla(263, 46%, 78%, 1.0)",
    transform: "matrix(0.9476249999999999,0.16709185509385915,0.1670918550938591,-0.9181621976903235,-33.47775657741812,514.85079174967)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob2.2a978aa3edc739c3831d475ebae17705.svg";
export { ForwardRef as ReactComponent };